module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--jawn"
  }, [_c('div', {
    staticClass: "spinner-inner",
    style: (_vm.styles)
  }, [_c('div', {
    staticClass: "jawn",
    style: (_vm.innerStyles)
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6d7f3fed"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-loading-spinner/src/components/Jawn.vue
// module id = 934
// module chunks = 170